export const FETCH_INVENTORY_ITEMS = 'FETCH_INVENTORY_ITEMS'